import React from "react";
import "./skeleton.css";

/** A single pulsing placeholder bar. Width accepts any CSS width value. */
export function SkeletonLine({ width = "100%", height = 14, className = "" }) {
  return <div className={`dash-skeleton ${className}`} style={{ width, height }} />;
}

/** Placeholder for a stat-tile-style card (label + big number). */
export function SkeletonCard({ lines = 2 }) {
  return (
    <div className="border rounded p-3 d-flex flex-column gap-2">
      <SkeletonLine width="50%" height={12} />
      {Array.from({ length: lines }).map((_, i) => (
        <SkeletonLine key={i} width={i === 0 ? "70%" : "40%"} height={i === 0 ? 24 : 12} />
      ))}
    </div>
  );
}

/** Placeholder for a table — a header-ish bar plus N row bars. */
export function SkeletonTable({ rows = 5 }) {
  return (
    <div className="d-flex flex-column gap-2">
      <SkeletonLine width="30%" height={14} />
      {Array.from({ length: rows }).map((_, i) => (
        <SkeletonLine key={i} height={18} />
      ))}
    </div>
  );
}

/** Placeholder for a chart area — one tall block. */
export function SkeletonChart({ height = 220 }) {
  return <SkeletonLine width="100%" height={height} className="dash-skeleton-block" />;
}
